import Vue from "vue/dist/vue.esm";
// 直近成績 選手表

var historyAthletesTable = Vue.extend({
  data: function() {
    return {
      isClickable: false
    }
  },
  template: `
  <table class="table table-vote-number table-align-middle">
      <thead class="bg-gray-lighter text-bold">
        <tr class="bg-gray-lighter" height="34">
          <th rowspan="3" height="68">枠番</th>
          <th rowspan="3" height="68">車番</th>
          <th rowspan="3">選手名</th>
          <th rowspan="3">年齢</th>
          <th rowspan="3">府県</th>
          <th rowspan="3">期別</th>
          <th colspan="9">3回前までの成績</th>
        </tr>
        <tr height="34">
          <th colspan="3">今回開催</th>
          <th colspan="3">前回開催</th>
          <th colspan="3">前々回開催</th>
        </tr>
        <tr height="34">
          <th>開催</th>
          <th>初日</th>
          <th>成績</th>
          <th>開催</th>
          <th>初日</th>
          <th>成績</th>
          <th>開催</th>
          <th>初日</th>
          <th>成績</th>
        </tr>
      </thead>
    <tbody v-for="(athlete, key, index) in raceInfo.race_athletes" 
      @click="addSyabanToEditCart(raceInfo.box.race_num, athlete.entry_num)" 
      :class="{'is-clickable': isClickable}"
      class="text-nowrap"
    >
      <tr :class="['bg-lighten-' + athlete.entry_num, {'is-disabled': !athlete.on_sale}]">
        <td height="68" :rowspan="joiningWakuNum(athlete.waku_num)" class="bg-white text-center">{{athlete.waku_num}}</td>
        <td height="68" :class="'bg-' + athlete.entry_num" class="text-center text-bold">{{athlete.entry_num}}</td>
        <td>{{athlete.name}}</td>
        <td>{{athlete.age}}</td>
        <td>{{athlete.pref_name}}</td>
        <td>{{athlete.graduate_period}}</td>
        <td>{{athlete.history_data1 ? athlete.history_data1.vel_name : ''}}</td>
        <td>{{athlete.history_data1.open_from ? moment(athlete.history_data1.open_from, 'YYYYMMDD').format('MM/DD') : ''}}</td>
        <td>
          <div v-if="athlete.history_data1">
            <span v-for="short_box in athlete.history_data1.short_boxes">
              <p>{{short_box.event_name}} {{short_box.rank || short_box.note}}</p>
            </span>
          </div>
        </td>
        <td>{{athlete.history_data2 ? athlete.history_data2.vel_name : ''}}</td>
        <td>{{athlete.history_data2.open_from ? moment(athlete.history_data2.open_from, 'YYYYMMDD').format('MM/DD') : ''}}</td>
        <td>
          <div v-if="athlete.history_data2">
            <span v-for="short_box in athlete.history_data2.short_boxes">
              <p>{{short_box.event_name}} {{short_box.rank || short_box.note}}</p>
            </span>
          </div>
        </td>
        <td>{{athlete.history_data3 ? athlete.history_data3.vel_name : ''}}</td>
        <td>{{athlete.history_data3.open_from ? moment(athlete.history_data3.open_from, 'YYYYMMDD').format('MM/DD') : ''}}</td>
        <td>
          <div v-if="athlete.history_data3">
            <span v-for="short_box in athlete.history_data3.short_boxes">
              <p>{{short_box.event_name}} {{short_box.rank || short_box.note}}</p>
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  `,

  methods: {
    addSyabanToEditCart: function(race_num, syaban) {
      this.$parent.$emit('addSyaban', race_num, syaban);
    },
    computeAvePoint: function(num) {
      return (Math.floor(num / 10) / 100).toPrecision(4);
    },
    // 同一の枠番がいくつ有るかを出力
    joiningWakuNum: function(num) {
      var race_athelets = this.raceInfo.race_athletes;
      var waku_nums = [];
      
      for (var key in race_athelets) {
        waku_nums.push(race_athelets[key].waku_num);
      }
      
      var count = 0;
      for (var i=0; i<waku_nums.length; i++) {
        count = (waku_nums[i] == num) ? count + 1 : count;
      }
      
      return count;
    },
    // 指定した車番の選手が同一枠番の最初かどうかの判定
    isFirstWaku: function(syaban) {
      var race_athelets = this.raceInfo.race_athletes;
      var waku_nums = [];
      var syabans = Object.keys(race_athelets);
      
      for (var key in race_athelets) {
        waku_nums.push(race_athelets[key].waku_num);
      }
      
      var targetIndex = waku_nums.indexOf(race_athelets[syaban].waku_num);
      
      if (syaban == syabans[targetIndex]) {
        return true;
      } else {
        return false;
      }
    }
  }
});

export default {
  historyAthletesTable
}
